export default __webpack_public_path__ + "static/media/lock-open.0ce0328f.svg";